import React, { useState } from 'react';

const FilterPanel = ({ filters, onFilterChange }) => {
    const [localFilters, setLocalFilters] = useState(filters);

    const statusOptions = [
        { value: '', label: 'All Statuses' },
        { value: 'incomplete', label: 'Incomplete' },
        { value: 'complete', label: 'Complete' },
        { value: 'pending_review', label: 'Pending Review' },
        { value: 'in_review', label: 'In Review' },
        { value: 'approved', label: 'Approved' },
        { value: 'rejected', label: 'Rejected' },
        { value: 'draft', label: 'Draft' },
        { value: 'submitted', label: 'Submitted' }
    ];

    const sortOptions = [
        { value: 'created_at', label: 'Date Created' },
        { value: 'updated_at', label: 'Last Updated' },
        { value: 'percent_complete', label: 'Completion %' },
        { value: 'id', label: 'ID' }
    ];

    const perPageOptions = [
        { value: 10, label: '10 per page' },
        { value: 15, label: '15 per page' },
        { value: 25, label: '25 per page' },
        { value: 50, label: '50 per page' }
    ];

    const handleInputChange = (field, value) => {
        const newFilters = { ...localFilters, [field]: value };
        setLocalFilters(newFilters);
    };

    const handleApplyFilters = () => {
        onFilterChange(localFilters);
    };

    const handleClearFilters = () => {
        const clearedFilters = {
            status: '',
            search: '',
            date_from: '',
            date_to: '',
            sort_by: 'created_at',
            sort_order: 'desc',
            per_page: 15,
            page: 1
        };
        setLocalFilters(clearedFilters);
        onFilterChange(clearedFilters);
    };

    const handleSortOrderToggle = () => {
        const newOrder = localFilters.sort_order === 'asc' ? 'desc' : 'asc';
        const newFilters = { ...localFilters, sort_order: newOrder };
        setLocalFilters(newFilters);
        onFilterChange(newFilters);
    };

    return (
        <div className="filter-panel mb-3">
            <div className="row">
                {/* Search */}
                <div className="col-md-3 mb-2">
                    <div className="form-group">
                        <label htmlFor="search">Search</label>
                        <input
                            type="text"
                            className="form-control"
                            id="search"
                            placeholder="Search by name, email, school..."
                            value={localFilters.search}
                            onChange={(e) => handleInputChange('search', e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && handleApplyFilters()}
                        />
                    </div>
                </div>

                {/* Status Filter */}
                <div className="col-md-2 mb-2">
                    <div className="form-group">
                        <label htmlFor="status">Status</label>
                        <select
                            className="form-control"
                            id="status"
                            value={localFilters.status}
                            onChange={(e) => handleInputChange('status', e.target.value)}
                        >
                            {statusOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Date From */}
                <div className="col-md-2 mb-2">
                    <div className="form-group">
                        <label htmlFor="date_from">From Date</label>
                        <input
                            type="date"
                            className="form-control"
                            id="date_from"
                            value={localFilters.date_from}
                            onChange={(e) => handleInputChange('date_from', e.target.value)}
                        />
                    </div>
                </div>

                {/* Date To */}
                <div className="col-md-2 mb-2">
                    <div className="form-group">
                        <label htmlFor="date_to">To Date</label>
                        <input
                            type="date"
                            className="form-control"
                            id="date_to"
                            value={localFilters.date_to}
                            onChange={(e) => handleInputChange('date_to', e.target.value)}
                        />
                    </div>
                </div>

                {/* Sort By */}
                <div className="col-md-2 mb-2">
                    <div className="form-group">
                        <label htmlFor="sort_by">Sort By</label>
                        <select
                            className="form-control"
                            id="sort_by"
                            value={localFilters.sort_by}
                            onChange={(e) => handleInputChange('sort_by', e.target.value)}
                        >
                            {sortOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Sort Order */}
                <div className="col-md-1 mb-2">
                    <div className="form-group">
                        <label>&nbsp;</label>
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-block"
                            onClick={handleSortOrderToggle}
                            title={`Sort ${localFilters.sort_order === 'asc' ? 'Descending' : 'Ascending'}`}
                        >
                            <i className={`fas fa-sort-${localFilters.sort_order === 'asc' ? 'up' : 'down'}`}></i>
                        </button>
                    </div>
                </div>
            </div>

            <div className="row">
                {/* Per Page */}
                <div className="col-md-2 mb-2">
                    <div className="form-group">
                        <label htmlFor="per_page">Per Page</label>
                        <select
                            className="form-control"
                            id="per_page"
                            value={localFilters.per_page}
                            onChange={(e) => handleInputChange('per_page', parseInt(e.target.value))}
                        >
                            {perPageOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="col-md-10 mb-2 d-flex align-items-end">
                    <div className="btn-group" role="group">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleApplyFilters}
                        >
                            <i className="fas fa-search mr-1"></i>
                            Apply Filters
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleClearFilters}
                        >
                            <i className="fas fa-times mr-1"></i>
                            Clear
                        </button>
                    </div>
                </div>
            </div>

            {/* Active Filters Display */}
            {(localFilters.status || localFilters.search || localFilters.date_from || localFilters.date_to) && (
                <div className="row">
                    <div className="col-12">
                        <div className="alert alert-info">
                            <strong>Active Filters:</strong>
                            {localFilters.status && (
                                <span className="badge badge-primary ml-2">
                                    Status: {statusOptions.find(s => s.value === localFilters.status)?.label}
                                </span>
                            )}
                            {localFilters.search && (
                                <span className="badge badge-info ml-2">
                                    Search: "{localFilters.search}"
                                </span>
                            )}
                            {localFilters.date_from && (
                                <span className="badge badge-warning ml-2">
                                    From: {localFilters.date_from}
                                </span>
                            )}
                            {localFilters.date_to && (
                                <span className="badge badge-warning ml-2">
                                    To: {localFilters.date_to}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FilterPanel; 